/**
 * The hour column of the custom time picker in the locale's own hour cycle: 1–12 with AM/PM
 * where the locale reads the clock that way (en-US), 0–23 otherwise (de, pl, uk, ja).
 * The value on the wire is always 24-hour "HH:mm".
 */

/** The hours the picker offers. */
export const pickerHours = (twelveHour: boolean): number[] =>
  twelveHour ? Array.from({ length: 12 }, (_, i) => i + 1) : Array.from({ length: 24 }, (_, i) => i);

/** A 24-hour wire hour as the picker shows it. */
export const toPickerHour = (hour24: number, twelveHour: boolean): number => {
  if (!twelveHour) return hour24;
  if (hour24 === 0) return 12;
  return hour24 > 12 ? hour24 - 12 : hour24;
};

/** The picker's hour (and AM/PM in a 12-hour locale) back as a 24-hour wire hour. */
export const toWireHour = (pickerHour: number, isAM: boolean, twelveHour: boolean): number => {
  if (!twelveHour) return pickerHour;
  if (pickerHour === 12) return isAM ? 0 : 12;
  return isAM ? pickerHour : pickerHour + 12;
};
